// extracted by mini-css-extract-plugin
export default {"signupDetailsForm":"SignupDetailsForm_signupDetailsForm__p+vXB","row":"SignupDetailsForm_row__oEIAq","sumbitButton":"SignupDetailsForm_sumbitButton__ZN0yk"};